import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { PhotoReportStatus as BasePhotoReportStatus } from '@eigtech/ui-shared-documator-web'
import { createFileRoute } from '@tanstack/react-router'
import { withRequiredPermissions } from '../../../../../lib/permissions'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/photo-report_/status')({
  component: () => <Component />,
})

function PhotoReportStatus() {
  const { claimNumber } = Route.useParams()

  return <BasePhotoReportStatus entityId={ensureClaimCorn(claimNumber)} />
}

const Component = withRequiredPermissions(PhotoReportStatus, {
  requiredPermissions: [
    { action: 'read', subject: 'claim' },
    { action: 'read', subject: 'document' },
  ],
})
